module.exports = __webpack_public_path__ + "static/img/icon-key.1298c60d.png";